import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import FiltersStyles from '@stories/Components/Filters/Filters.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
import HeadingStyles from '../Global/Typography/Heading.styles';
const Container = styled(SectionWrapper) `
  ${setCssVar('fgColor', brand.black)};


  ${FiltersStyles.Container} {
    margin: 0 0 80px;
  }
`;
const Message = styled.p `
  ${ParagraphStyles.RegularStyles}
`;
const Loading = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  height: 100%;
  justify-content: center;
  width: 100%;
  z-index: 100;
`;
const CtaWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-top: 84px;
`;
const ListTitle = styled.h2 `
  ${HeadingStyles.H2Styles};
  color: ${cssVar('fgColor')};
  margin: 50px 0 30px;
`;
const ResultIndicator = styled.div `
  flex: 1 0 100%;
  text-align: center;
  margin-top: 20px;

  @media ${from(Device.Tablet)} {
    margin-top: 25px;
  }
`;
const ResultIndicatorContent = styled.span `
  ${fonts.matter.regular};
  font-size: 14px;
  line-height: 20px;  

  @media ${from(Device.Tablet)} {
    font-size: 18px;
    line-height: 26px;
  }
`;
export default {
    Container,
    CtaWrapper,
    ListTitle,
    Loading,
    Message,
    ResultIndicator,
    ResultIndicatorContent,
};
